import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Interpolate } from 'react-i18next';
import ProtectedButton from '../../containers/protected-button';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './login-to-comment.scss';

export const LoginToComment = ({ contentFontClassName, t }) =>
  <div className={classNames(styles.container, contentFontClassName)}>
    <ProtectedButton tagName="div" className={classNames(styles.loginLink, 'forum-text-color')}>
      <Interpolate
        i18nKey="login-to-comment.login-to-join"
        login={<span className="button-color">
          {t('login-to-comment.login')}
        </span>}
      />
    </ProtectedButton>
  </div>;

LoginToComment.propTypes = {
  contentFontClassName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslate(withFontClassName(LoginToComment));



// WEBPACK FOOTER //
// ./app/components/login-to-comment/login-to-comment.js